import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'DateOption'
})
export default class extends Vue {
  pickerOptions: any = {
    shortcuts: [
      {
        text: '今天',
        onClick(picker: any) {
          const end = new Date()
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 1 - 1)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '昨天',
        onClick(picker: any) {
          const end = new Date()
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
          end.setTime(start.getTime() - 1000 + 3600 * 1000 * 24 * 1)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '过去七天',
        onClick(picker: any) {
          const end = new Date()
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          end.setTime(start.getTime() - 1000 + 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '过去30天',
        onClick(picker: any) {
          const end = new Date()
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          end.setTime(start.getTime() - 1000 + 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      }
    ]
  }
  defaultTime: string[] = ['00:00:00', '23:59:59']
}
